"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorProfile = void 0;
exports.editorProfile = {
    name: 'editor',
    methods: ['discardHighlight', 'highlight', 'addAnnotation', 'clearAnnotations', 'discardHighlightAt', 'gotoLine'],
};
//# sourceMappingURL=profile.js.map